import React from "react";
import WhatsAppGlyph from "./WhatsAppGlyph";

// Real WhatsApp brand green — same value WhatsAppButton.jsx's floating
// button already uses, so this pill reads as "the same WhatsApp" rather
// than a differently-branded green that happens to be close.
const WHATSAPP_GREEN = "#25D366";

// Static, not admin-configurable like the Zoom link/support number are —
// this is one fixed community channel, not something expected to change
// often enough to need its own settings field. Update here directly if
// that ever changes.
export const WHATSAPP_COMMUNITY_URL = "https://whatsapp.com/channel/0029VbDZSFl9Bb664S3Fv20X";

// Its own separate pill, not squeezed into the end of LiveClassCard's
// compact bar — the two used to share one row, which meant "no live class
// scheduled" and "join our community" (a standing, unrelated invite) sat
// crammed together in the same sentence-length space, competing for room
// on anything narrower than a wide desktop. Same visual language as
// LiveClassCard's own compact pill (rounded-full, white, honeySoft border)
// so the two read as siblings sitting next to each other, not a mismatched
// afterthought.
//
// h-full: when this sits side by side with LiveClassCard (Dashboard.jsx's
// flex row), the two pills' own natural content height genuinely differs —
// Live Class can wrap onto two lines (title + up to three timezones),
// this card is always one line. A flex row's default cross-axis stretch
// already makes both WRAPPING columns the same height; without h-full
// here this pill just sat shorter *inside* that taller column instead of
// actually filling it, which is the mismatched-height/misaligned look
// this was built to fix.
export default function WhatsAppCommunityCard() {
    return (
        <div
            className="h-full rounded-full bg-white border border-honeySoft shadow-sm shadow-black/5 px-4 sm:px-5 py-2.5 flex items-center justify-between gap-3 flex-wrap sm:flex-nowrap"
            data-testid="whatsapp-community-card"
        >
            <div className="flex items-center gap-3 min-w-0">
                <div className="rounded-full p-1.5 shrink-0" style={{ backgroundColor: `${WHATSAPP_GREEN}1A` }}>
                    <WhatsAppGlyph className="w-4 h-4" style={{ color: WHATSAPP_GREEN }} />
                </div>
                <p className="font-display font-semibold text-charcoal text-sm sm:text-base truncate">
                    Join our WhatsApp Community
                </p>
            </div>
            <a
                href={WHATSAPP_COMMUNITY_URL}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="whatsapp-community-link"
                className="inline-flex items-center gap-1.5 rounded-full text-white px-4 py-1.5 text-sm font-display font-bold shadow-sm hover:brightness-105 shrink-0"
                style={{ backgroundColor: WHATSAPP_GREEN, boxShadow: `0 1px 2px 0 ${WHATSAPP_GREEN}33` }}
            >
                <WhatsAppGlyph className="w-3.5 h-3.5" /> Community
            </a>
        </div>
    );
}
